import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateShareKeyListQuery } from "@/queries/query-share-key";

interface CreateShareKeyParams {
  name: string;
  expiresAt?: Date | null;
}

export const useCreateShareKey = (publicationId: string) => {
  const invalidateShareKeyListQuery = useInvalidateShareKeyListQuery();

  return useMutationWithErrorHandler(async (createShareKeyParams: CreateShareKeyParams) => {
    const response = await getRanaApiV1().ApiKeysApi.apiKeyCreate({
      apiKeyCreateV2: {
        name: createShareKeyParams.name,
        expiresAt: createShareKeyParams.expiresAt,
        relatedTo: {
          type: "publication",
          id: publicationId,
        },
      },
    });

    invalidateShareKeyListQuery(publicationId);

    return response;
  });
};
